export enum ToggleState {
  open = 'open',
  closed = 'closed',
}
